import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import FlexBox from 'flexbox-react';
import { Switch, Input } from 'react-toolbox';
import BreakLine from 'components/BreakLine';
import styles from 'styles/form';
import { MILLWORK_SURFACES } from 'config/constants';

const titleStyle = cx(styles.bottomTitle, styles.childTitle);
const smallInput = cx(styles.inputs, styles.smallInput);

class PhaseSpecificInfoForm extends Component {
  constructor(props) {
    super(props);
    const { onChange, onMillworkChange, onMillworkBooleanChange } = this.props;

    this.handleCustomerSpeaksEnglish = onChange.bind(this, 'customer_speaks_english');
    this.handleCustomerSpeaksSpanish = onChange.bind(this, 'customer_speaks_spanish');
    this.handleHasPower = onChange.bind(this, 'customer_has_power');
    this.handleHasWater = onChange.bind(this, 'customer_has_water');
    this.handleHasClimateControl = onChange.bind(this, 'customer_has_climate_control');
    this.handleNeedMoveFurniture = onChange.bind(this, 'need_move_furniture');
    this.handleNeedMoveFurnitureOversized = onChange.bind(this, 'need_move_furniture_oversized');
    this.handleNeedMoveAppliances = onChange.bind(this, 'need_move_appliances');
    this.handleNeedSubfloorPrep = onChange.bind(this, 'need_subfloor_prep');
    this.handleNeedSubfloorReplacement = onChange.bind(this, 'need_subfloor_replacement');
    this.handleIsNaildownHardwood = onChange.bind(this, 'is_naildown_hardwood');
    this.handleIsGluedownHardwood = onChange.bind(this, 'is_gluedown_hardwood');
    this.handleIsFloatingHardwood = onChange.bind(this, 'is_floating_hardwood');
    this.handleIsCaliBambooHardwood = onChange.bind(this, 'is_cali_bamboo_hardwood');
    this.handleIsStepsHardwood = onChange.bind(this, 'is_steps_hardwood');
    this.handleIsStretchInCarpet = onChange.bind(this, 'is_stretch_in_carpet');
    this.handleIsGluedownCarpet = onChange.bind(this, 'is_gluedown_carpet');
    this.handleIsBindingCarpet = onChange.bind(this, 'is_binding_carpet');
    this.handleIsPatternMatchCarpet = onChange.bind(this, 'is_pattern_match_carpet');
    this.handleIsBerberCarpet = onChange.bind(this, 'is_berber_carpet');
    this.handleIsStepsCarpet = onChange.bind(this, 'is_steps_carpet');
    this.handleIsFloorTile = onChange.bind(this, 'is_floor_tile');
    this.handleIsBacksplashTile = onChange.bind(this, 'is_backsplash_tile');
    this.handleIsBacksplashGlass = onChange.bind(this, 'is_backsplash_glass');
    this.handleIsBacksplashBlocking = onChange.bind(this, 'is_backsplash_blocking');
    this.handleIsPatternsTile = onChange.bind(this, 'is_patterns_tile');
    this.handleIsLargeFormatTile = onChange.bind(this, 'is_large_format_tile');
    this.handleIsVinylSheet = onChange.bind(this, 'is_vinyl_sheet');
    this.handleIsVinylTile = onChange.bind(this, 'is_vct_lvt');
    this.handleIsGluedownVinylPlank = onChange.bind(this, 'is_gluedown_vinyl_plank');
    this.handleIsFloatingVinylPlank = onChange.bind(this, 'is_floating_vinyl_plank');
    this.handleNeedRemoveReplaceToilet = onChange.bind(this, 'need_remove_replace_toilet');
    this.handleNeedRemoveNaildownHardwood = onChange.bind(this, 'need_remove_naildown_hardwood');
    this.handleNeedRemoveFloatingHardwood = onChange.bind(this, 'need_remove_floating_hardwood');
    this.handleNeedRemoveGluedownHardwood = onChange.bind(this, 'need_remove_gluedown_hardwood');
    this.handleNeedRemoveOverPadCarpet = onChange.bind(this, 'need_remove_over_pad_carpet');
    this.handleNeedRemoveGluedownCarpet = onChange.bind(this, 'need_remove_gluedown_carpet');
    this.handleNeedRemoveLaminate = onChange.bind(this, 'need_remove_laminate');
    this.handleNeedRemoveTile = onChange.bind(this, 'need_remove_tile');
    this.handleNeedRemoveGluedownVinyl = onChange.bind(this, 'need_remove_gluedown_vinyl');
    this.handleNeedRemoveVinylPlank = onChange.bind(this, 'need_remove_vinyl_plank');
    this.handleNeedRemoveBacksplash = onChange.bind(this, 'need_remove_backsplash');
    this.handleNeedInstallBaseboard = onChange.bind(this, 'need_install_baseboard');
    this.handleNeedHardSurfaceTransitions = onChange.bind(this, 'need_hardsurface_transitions');
    this.handleNumDoors = onMillworkChange.bind(this, 'num_doors');
    this.handleNumWindows = onMillworkChange.bind(this, 'num_windows');
    this.handlePermitRequired = onMillworkBooleanChange.bind(this, 'permit_required');
  }

  render = () => {
    const { phase: { surface_type: { id: surfaceId }, phase_specific } } = this.props;
    return (<div>
      <FlexBox flexWrap="wrap" className={styles.divider}>
        <h5 className={titleStyle}>Specific Information - General</h5>
        <BreakLine />
        <Switch
          className={styles.specificSwitch}
          name="hasPower"
          label="Has Power"
          onChange={this.handleHasPower}
          checked={phase_specific.customer_has_power}
          disabled={false}
        />
        <Switch
          className={styles.specificSwitch}
          name="hasClimateControl"
          label="Has Climate Control"
          onChange={this.handleHasClimateControl}
          checked={phase_specific.customer_has_climate_control}
          disabled={false}
        />
        <Switch
          className={styles.specificSwitch}
          name="hasWater"
          label="Has Water"
          onChange={this.handleHasWater}
          checked={phase_specific.customer_has_water}
          disabled={false}
        />
        <Switch
          className={styles.specificSwitch}
          name="needMoveFurniture"
          label="Moving Furniture"
          onChange={this.handleNeedMoveFurniture}
          checked={phase_specific.need_move_furniture}
          disabled={false}
        />
        <Switch
          className={styles.specificSwitch}
          name="needMoveFurnitureOversized"
          label="Moving Oversized Furniture"
          onChange={this.handleNeedMoveFurnitureOversized}
          checked={phase_specific.need_move_furniture_oversized}
          disabled={false}
        />
        <Switch
          className={styles.specificSwitch}
          name="needMoveAppliances"
          label="Moving Appliances"
          onChange={this.handleNeedMoveAppliances}
          checked={phase_specific.need_move_appliances}
          disabled={false}
        />
        {!MILLWORK_SURFACES.includes(surfaceId) && <Fragment>
          <Switch
            className={styles.specificSwitch}
            name="needSubfloorPrep"
            label="Subfloor Prep"
            onChange={this.handleNeedSubfloorPrep}
            checked={phase_specific.need_subfloor_prep}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needSubfloorReplacement"
            label="Subfloor Replacement"
            onChange={this.handleNeedSubfloorReplacement}
            checked={phase_specific.need_subfloor_replacement}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="NeedInstallBaseboard"
            label="Installing Baseboard/Moulding"
            onChange={this.handleNeedInstallBaseboard}
            checked={phase_specific.need_install_baseboard}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needHardSurfaceTransitions"
            label="Installing Hard Surface Transitions"
            onChange={this.handleNeedHardSurfaceTransitions}
            checked={phase_specific.need_hardsurface_transitions}
            disabled={false}
          />
        </Fragment>}
      </FlexBox>
      <BreakLine />
      {MILLWORK_SURFACES.includes(surfaceId) ? (<FlexBox flexWrap="wrap" className={styles.divider}>
        <h5 className={titleStyle}>Specific Information - Millwork</h5>
        <BreakLine />
        <Input
          className={smallInput}
          label="Number of Doors"
          onChange={this.handleNumDoors}
          value={phase_specific.millwork_specifics.num_doors}
        />
        <Input
          className={smallInput}
          label="Number of Windows"
          onChange={this.handleNumWindows}
          value={phase_specific.millwork_specifics.num_windows}
        />
        <Switch
          className={styles.specificSwitch}
          name="permitRequired"
          label="Permit Required"
          onChange={this.handlePermitRequired}
          checked={phase_specific.millwork_specifics.permit_required || false}
          disabled={false}
        />
      </FlexBox>) : <Fragment>
        {[1, 8, 9].includes(surfaceId) && <Fragment>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <h5 className={titleStyle}>Specific Information - Hardwood</h5>
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isNaildownHardwood"
              label="Naildown Hardwood"
              onChange={this.handleIsNaildownHardwood}
              checked={phase_specific.is_naildown_hardwood}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isGluedownHardwood"
              label="Gluedown Hardwood"
              onChange={this.handleIsGluedownHardwood}
              checked={phase_specific.is_gluedown_hardwood}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isFloatingHardwood"
              label="Floating Hardwood"
              onChange={this.handleIsFloatingHardwood}
              checked={phase_specific.is_floating_hardwood}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isCaliBambooHardwood"
              label="Cali Bamboo"
              onChange={this.handleIsCaliBambooHardwood}
              checked={phase_specific.is_cali_bamboo_hardwood}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isStepsHardwood"
              label="Hardwood Steps"
              onChange={this.handleIsStepsHardwood}
              checked={phase_specific.is_steps_hardwood}
              disabled={false}
            />
          </FlexBox>
          <BreakLine />
        </Fragment>}
        {[2, 8, 9].includes(surfaceId) && <Fragment>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <h5 className={titleStyle}>Specific Information - Carpet</h5>
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isStretchInCarpet"
              label="Stretch In Carpet"
              onChange={this.handleIsStretchInCarpet}
              checked={phase_specific.is_stretch_in_carpet}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isGluedownCarpet"
              label="Gluedown Carpet"
              onChange={this.handleIsGluedownCarpet}
              checked={phase_specific.is_gluedown_carpet}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isBindingCarpet"
              label="Binding Carpet"
              onChange={this.handleIsBindingCarpet}
              checked={phase_specific.is_binding_carpet}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isPatternMatchCarpet"
              label="Pattern Match Carpet"
              onChange={this.handleIsPatternMatchCarpet}
              checked={phase_specific.is_pattern_match_carpet}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isBerberCarpet"
              label="Berber Carpet"
              onChange={this.handleIsBerberCarpet}
              checked={phase_specific.is_berber_carpet}
              disabled={false}
            />
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isStepsCarpet"
              label="Carpet Steps"
              onChange={this.handleIsStepsCarpet}
              checked={phase_specific.is_steps_carpet}
              disabled={false}
            />
          </FlexBox>
          <BreakLine />
        </Fragment>}
        {[3, 7, 8, 9].includes(surfaceId) && <Fragment>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <h5 className={titleStyle}>Specific Information - Tile/Backsplash</h5>
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isFloorTile"
              label="Floor Tile"
              onChange={this.handleIsFloorTile}
              checked={phase_specific.is_floor_tile}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isBacksplashTile"
              label="Backsplash Tile"
              onChange={this.handleIsBacksplashTile}
              checked={phase_specific.is_backsplash_tile}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isBacksplashGlass"
              label="Glass Backsplash"
              onChange={this.handleIsBacksplashGlass}
              checked={phase_specific.is_backsplash_glass}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isBacksplashBlocking"
              label="Backsplash Blocking"
              onChange={this.handleIsBacksplashBlocking}
              checked={phase_specific.is_backsplash_blocking}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isPatternsTile"
              label="Tile Patterns"
              onChange={this.handleIsPatternsTile}
              checked={phase_specific.is_patterns_tile}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isLargeFormatTile"
              label="Large Format Tile"
              onChange={this.handleIsLargeFormatTile}
              checked={phase_specific.is_large_format_tile}
              disabled={false}
            />
          </FlexBox>
          <BreakLine />
        </Fragment>}
        {[5, 6, 8, 9].includes(surfaceId) && <Fragment>
          <FlexBox flexWrap="wrap" className={styles.divider}>
            <h5 className={titleStyle}>Specific Information - Vinyl/Plank</h5>
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isVinylSheet"
              label="Sheet Vinyl"
              onChange={this.handleIsVinylSheet}
              checked={phase_specific.is_vinyl_sheet}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isVctLvt"
              label="Vinyl Tile"
              onChange={this.handleIsVinylTile}
              checked={phase_specific.is_vct_lvt}
              disabled={false}
            />
            <Switch
              className={styles.specificSwitch}
              name="isGluedownVinylPlank"
              label="Gluedown VP"
              onChange={this.handleIsGluedownVinylPlank}
              checked={phase_specific.is_gluedown_vinyl_plank}
              disabled={false}
            />
            <BreakLine />
            <Switch
              className={styles.specificSwitch}
              name="isFloatingVinylPlank"
              label="Floating VP"
              onChange={this.handleIsFloatingVinylPlank}
              checked={phase_specific.is_floating_vinyl_plank}
              disabled={false}
            />
          </FlexBox>
          <BreakLine />
        </Fragment>}
        <FlexBox flexWrap="wrap" className={styles.divider}>
          <h5 className={titleStyle}>Specific Information - Removal</h5>
          <BreakLine />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveReplaceToilet"
            label="Remove/Replace Toilet"
            onChange={this.handleNeedRemoveReplaceToilet}
            checked={phase_specific.need_remove_replace_toilet}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveNaildownHardwood"
            label="Removing Naildown Hardwood"
            onChange={this.handleNeedRemoveNaildownHardwood}
            checked={phase_specific.need_remove_naildown_hardwood}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveFloatingHardwood"
            label="Removing Floating Hardwood"
            onChange={this.handleNeedRemoveFloatingHardwood}
            checked={phase_specific.need_remove_floating_hardwood}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveGluedownHardwood"
            label="Removing Gluedown Hardwood"
            onChange={this.handleNeedRemoveGluedownHardwood}
            checked={phase_specific.need_remove_gluedown_hardwood}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveOverPadCarpet"
            label="Removing Carpet Over Pad"
            onChange={this.handleNeedRemoveOverPadCarpet}
            checked={phase_specific.need_remove_over_pad_carpet}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveGluedownCarpet"
            label="Removing Gluedown Carpet"
            onChange={this.handleNeedRemoveGluedownCarpet}
            checked={phase_specific.need_remove_gluedown_carpet}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveLaminate"
            label="Removing Laminate"
            onChange={this.handleNeedRemoveLaminate}
            checked={phase_specific.need_remove_laminate}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveTile"
            label="Removing Tile"
            onChange={this.handleNeedRemoveTile}
            checked={phase_specific.need_remove_tile}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveGluedownVinyl"
            label="Removing Gluedown Vinyl"
            onChange={this.handleNeedRemoveGluedownVinyl}
            checked={phase_specific.need_remove_gluedown_vinyl}
            disabled={false}
          />
          <BreakLine />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveVinylPlank"
            label="Removing Vinyl Plank"
            onChange={this.handleNeedRemoveVinylPlank}
            checked={phase_specific.need_remove_vinyl_plank}
            disabled={false}
          />
          <Switch
            className={styles.specificSwitch}
            name="needRemoveBacksplash"
            label="Removing Backsplash"
            onChange={this.handleNeedRemoveBacksplash}
            checked={phase_specific.need_remove_backsplash}
            disabled={false}
          />
        </FlexBox>
      </Fragment>}
    </div>);
  }
}

PhaseSpecificInfoForm.propTypes = {
  onChange: PropTypes.func,
  onMillworkChange: PropTypes.func,
  onMillworkBooleanChange: PropTypes.func,
  errors: PropTypes.object,
  phase: PropTypes.object,
};

export default PhaseSpecificInfoForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseEdit/components/phaseSpecificInfoForm.jsx